import ClientOAuth2 from 'client-oauth2';
import TOKEN from './token';
import getPkce from 'oauth-pkce';
import { appConfig } from '../../config';
const AUTH_CODE_VERIFIER_COOKIE_NAME = 'mariana-auth-code-verifier';
const getMarianaClient = (tenant: string) => {
  const TENANT_URL = appConfig.marianaAppUrl.replace('_tenant_', tenant);
  return new ClientOAuth2({
    clientId: appConfig.oauth.clientId,
    accessTokenUri: TENANT_URL + '/o/token/',
    authorizationUri: TENANT_URL + '/o/authorize',
    redirectUri: window.location.origin,
    scopes: ['read:account'],
  });
};
const generatePkce = async (): Promise<{
  verifier: string;
  challenge: string;
}> => {
  return new Promise((resolve, reject) =>
    getPkce(43, (error, { verifier, challenge }) => {
      if (error) {
        reject(error);
      }
      resolve({ verifier, challenge });
    }),
  );
};
export const login = async (tenant: string) => {
  if (!tenant) return;
  const { verifier, challenge } = await generatePkce();
  const { verifier: stateString } = await generatePkce();
  localStorage.setItem(AUTH_CODE_VERIFIER_COOKIE_NAME, verifier);
  const authUri = getMarianaClient(tenant).code.getUri({
    state: stateString,
    query: {
      code_challenge: challenge,
      code_challenge_method: 'S256',
      response_type: 'code',
    },
  });
  window.location.assign(authUri);
};
export const logout = () => {
  TOKEN.remove();
};
const authenticate = async (tenant: string, url: URL, code: string) => {
  const verifier = localStorage.getItem(AUTH_CODE_VERIFIER_COOKIE_NAME);
  // uses `client-oauth2`'s `getToken` method, passing in extra PKCE related values
  // to the `body` key
  const token = await getMarianaClient(tenant).code.getToken(url, {
    body: {
      grant_type: 'authorization_code',
      code,
      code_verifier: verifier as string,
    },
  });
  TOKEN.setSessionStorage(token.data.access_token);

  return token.data.access_token;
};

export async function checkAuthenticationToken(
  tenant: string,
): Promise<string | undefined> {
  const url = new URL(location.href);
  const code = url.searchParams.get('code');

  let token = TOKEN.get();
  if (token) return token;
  if (code && tenant) {
    token = await authenticate(tenant, url, code);
  }

  return token;
}

export const isUnitTestActive = (tenant: string): boolean => {
  return tenant === 'unit-test';
};
